/**
 * Method that checks if an unit is valid
 * @param {string} inputUnit
 * @returns {boolean}
 */
export const isAValidUnits = (inputUnit: string): boolean => {
  if (/^-?\d+\.?\d*$/.test(inputUnit)) {
    if (Number(inputUnit) <= -1 || Number(inputUnit) >= 1) {
      return true;
    }
  }
  return false;
};

/**
 * Method that transform units a valid form
 * @param {number} inputUnit
 * @returns {number}
 */
export const parseUnits = (inputUnit: number): number => {
  if (inputUnit < 0) {
    inputUnit *= -1;
  }
  return Math.floor(inputUnit);
};
